// extracted by mini-css-extract-plugin
export var borderRadius = "_8q-4";
export var large = "_8q-3";
export var logoContainer = "_8q-0";
export var nameLogo = "_8q-2";
export var small = "_8q-1";